import { QueryDocumentSnapshot } from 'firebase/firestore'
import { HelpItemComponent } from './HelpItem'
import { HelpItem } from '../types'

interface HelpListProps {
  docs: QueryDocumentSnapshot<HelpItem>[]
  isAdmin: boolean
  onDelete: (id: string) => void
}

export const HelpList = ({ docs, isAdmin, onDelete }: HelpListProps) => {
  return (
    <>
      {docs.map((doc) => {
        const item = doc.data()

        return (
          <HelpItemComponent
            key={doc.id}
            item={item}
            isAdmin={isAdmin}
            onDelete={() => onDelete(doc.id)}
          />
        )
      })}
    </>
  )
}
